import React from 'react';

import Header from '../components/header/Header';
import Hero from '../components/hero/Hero';
import Testimonial from '../components/testimonial/testimonial-web/TestimonialWeb';
import Bio from '../components/bio/Bio';
import Layout from '../components/imageAndGraphics';
import VideoLayout from '../components/videoLayout/VideoLayout';
import Contact from '../components/contact/Contact';
import Footer from '../components/footer/Footer';

const landing = ({user}) => {
    return (
        <div>
            <Header isHomePage={true} />
            <Hero />
            <Testimonial />
            <Bio />
            <Layout title="PHOTOS" btnLink="/view-images" type="image" />
            <VideoLayout />
            <Layout title="GRAPHICS" btnLink="/view-graphics" type="graphics" />
            <Contact />
            <Footer />
        </div>
    );
};

export default landing;


// WEBPACK FOOTER //
// ./src/pages/landing.js